import { Link } from 'react-router-dom'

import ErrorLayout from '~/layouts/ErrorLayout'

const NotFound = () => (
  <ErrorLayout>
    <div className="text-center">
      <div className="mb-2 text-6xl font-bold text-gray-300">404</div>
      <h1 className="mb-4 text-lg text-gray-500">Page Not Found</h1>
      <Link to="/dashboard" className="text-sm font-medium text-gray-400 hover:text-jba-blue">
        Back to Home
      </Link>
    </div>
  </ErrorLayout>
)

export default NotFound
